export default __webpack_public_path__ + "static/covid-banner-img-efdd9a360484ed611df63dda533a7b6f.png";